import React, { createContext, useState, useEffect } from "react";

export const ContextProvider = createContext();

const ValueProvider = ({ children }) => {

  const [selectedOption, setSelectedOption] = useState("admin");
  const [productSelected, setProductSelected] = useState(() => {
    return localStorage.getItem("productSelected") || "";
  });
  const [planSelected, setPlanSelected] = useState(() => {
    return localStorage.getItem("planSelected") || "";
  });
  const [planTypeSelected, setPlanTypeSelected] = useState(() => {
    return localStorage.getItem("planTypeSelected") || "";
  });

  useEffect(() => {
    localStorage.setItem("productSelected", productSelected);
  }, [productSelected]);

  useEffect(() => {
    localStorage.setItem("planSelected", planSelected);
  }, [planSelected]);

  useEffect(() => {
    localStorage.setItem("planTypeSelected", planTypeSelected);
  }, [planTypeSelected]);

  return (
    <ContextProvider.Provider
      value={{
        productSelected,
        setProductSelected,
        planSelected,
        setPlanSelected,
        planTypeSelected,
        setPlanTypeSelected,
        selectedOption,
        setSelectedOption,
      }}
    >
      {children}
    </ContextProvider.Provider>
  );
};

export default ValueProvider;
